import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://api.nowatt.app',
});

// Ajouter le token automatiquement
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('nowatt_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Jeton expiré en cours d'utilisation (app ouverte plus d'une heure) : on le renouvelle
// une seule fois puis on rejoue la requête. Si le renouvellement échoue, la session est
// vidée et l'app revient à l'écran de connexion (événement écouté par App.js).
export const SESSION_EXPIRED_EVENT = 'nowatt:session-expired';
const NO_RETRY = ['/auth/login', '/auth/register', '/auth/refresh', '/auth/logout'];
let refreshing = null; // un seul renouvellement à la fois, partagé par les requêtes en attente

function refreshSession() {
  if (!refreshing) {
    const refresh_token = localStorage.getItem('nowatt_refresh_token');
    refreshing = (refresh_token
      ? axios.post(`${API.defaults.baseURL}/auth/refresh`, { refresh_token })
      : Promise.reject(new Error('NO_REFRESH_TOKEN'))
    ).then((r) => {
      localStorage.setItem('nowatt_token', r.data.access_token);
      if (r.data.refresh_token) localStorage.setItem('nowatt_refresh_token', r.data.refresh_token);
      return r.data.access_token;
    }).finally(() => { refreshing = null; });
  }
  return refreshing;
}

API.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;
    const status = error.response?.status;
    const skip = !config || config._retried || NO_RETRY.some((u) => (config.url || '').startsWith(u));
    if (status !== 401 || skip) throw error;
    config._retried = true;
    try {
      const token = await refreshSession();
      config.headers = { ...config.headers, Authorization: `Bearer ${token}` };
      return API(config);
    } catch {
      localStorage.removeItem('nowatt_token');
      localStorage.removeItem('nowatt_refresh_token');
      localStorage.removeItem('nowatt_user');
      window.dispatchEvent(new Event(SESSION_EXPIRED_EVENT));
      throw error;
    }
  }
);

export const auth = {
  register: (data) => API.post('/auth/register', data),
  login: (data) => API.post('/auth/login', data),
  logout: () => API.post('/auth/logout'),
};

export const pdl = {
  connect: (data) => API.post('/pdl/connect', data),
  getMyPdl: () => API.get('/pdl/my-pdl'),
};

export const offers = {
  getAll: () => API.get('/offers/all'),
  compare: (kwh) => API.get(`/offers/compare/${kwh}`),
};

export const recommendation = {
  getBestOffer: (pdlId) => API.get(`/recommendation/my-best-offer/${pdlId}`),
};
export const stripe = {
  getConfig: () => API.get('/stripe/config'),
  createCheckoutSession: () => API.post('/stripe/create-checkout-session'),
};
export default API;
